import React, {useEffect} from 'react';
import styles from './QuestionLeft.module.css';
import { useTranslation } from "react-i18next";

const QuestionLeft = ({ title, content }) => {
  const { t } = useTranslation();
  useEffect(() => {
  }, []);

  return (
    <div className={`content`}>
      <div className={`header`}>
        <div className={`headerTab selected`}
        >{t('Description')}
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.title}>
          {title}
        </div>
        <div className={styles.htmlContent}
             dangerouslySetInnerHTML={{__html: content}}/>
      </div>
    </div>
  );
};

export default QuestionLeft;
